import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import { OsAllocationPage } from '@contracts';

export const Route = createFileRoute('/_app/os/surfaces-allocation')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.SurfacesAllocation);
  },
  component: OsAllocationPage,
});
